export const FORM_NAME_PREVIEW_GATE = 'previewGate'

// account create
export const FORM_INPUT_NAME_FIRST_NAME = 'firstName'
export const FORM_INPUT_NAME_LAST_NAME = 'lastName'
export const FORM_INPUT_NAME_EMAIL = 'email'
export const FORM_INPUT_NAME_EMAIL_CONFIRM = 'emailConfirm'
export const FORM_INPUT_NAME_PASSWORD = 'password'
export const FORM_INPUT_NAME_REPEATED_PASSWORD = 'repeatedPassword'
export const FORM_INPUT_NAME_TERMS = 'terms'
export const FORM_INPUT_NAME_EMAIL_OPT_IN = 'emailOptIn'

// gifting
export const FORM_INPUT_NAME_GIFT_GIVER_FIRST_NAME = 'giverFirstName'
export const FORM_INPUT_NAME_GIFT_GIVER_LAST_NAME = 'giverLastName'
export const FORM_INPUT_NAME_GIFT_GIVER_EMAIL = 'giverEmail'
export const FORM_INPUT_NAME_GIFT_GIVER_CONFIRM_EMAIL = 'giverConfirmEmail'
export const FORM_INPUT_NAME_GIFT_GIVER_ANONYMOUS = 'giverAnonymous'
export const FORM_INPUT_NAME_GIFT_GIVER_TERMS_CONDITIONS = 'giverTermsConditions'
export const FORM_INPUT_NAME_GIFT_GIVER_PAYMENT_TYPE = 'giverPaymentType'
export const FORM_INPUT_NAME_GIFT_RECIPIENT_FIRST_NAME = 'recipientFirstName'
export const FORM_INPUT_NAME_GIFT_RECIPIENT_LAST_NAME = 'recipientLastName'
export const FORM_INPUT_NAME_GIFT_RECIPIENT_EMAIL = 'recipientEmail'
export const FORM_INPUT_NAME_GIFT_RECIPIENT_CONFIRM_EMAIL = 'recipientConfirmEmail'
export const FORM_INPUT_NAME_GIFT_RECIPIENT_MESSAGE = 'recipientMessage'
export const FORM_INPUT_NAME_GIFT_RECIPIENT_START_DATE = 'recipientSendDate'
